import { BModal } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBModal = createEgBootstrapProxy("EgBModal", BModal);
